// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type CopyCampaignMessageMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type CopyCampaignMessageMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { messageAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignMessageActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignMessageActionModelAsEditor, 'id' | 'copy'>
      )> }
    )> }
  )> }
);

export type CopyTopicShareActionMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type CopyTopicShareActionMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { topicShareAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignTopicShareActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignTopicShareActionModelAsEditor, 'id' | 'copy'>
      )> }
    )> }
  )> }
);

export type CopySurveyShareActionMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type CopySurveyShareActionMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { surveyShareAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignSurveyShareActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignSurveyShareActionModelAsEditor, 'id' | 'copy'>
      )> }
    )> }
  )> }
);

export type CopyPathwayShareActionMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type CopyPathwayShareActionMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { pathwayShareAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignPathwayShareActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignPathwayShareActionModelAsEditor, 'id' | 'copy'>
      )> }
    )> }
  )> }
);

export type CopyCampaignEmailMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type CopyCampaignEmailMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { emailAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignEmailActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignEmailActionModelAsEditor, 'id' | 'copy'>
      )> }
    )> }
  )> }
);

export type CopyCampaignBannerMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type CopyCampaignBannerMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { banner?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignBannerModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignBannerModelAsEditor, 'id' | 'copy'>
      )> }
    )> }
  )> }
);

export type CopyCertificationShareActionMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type CopyCertificationShareActionMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { certificationShareAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignCertificationShareActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignCertificationShareActionModelAsEditor, 'id' | 'copy'>
      )> }
    )> }
  )> }
);


export const CopyCampaignMessageDocument = gql`
    mutation copyCampaignMessage($id: PositiveInt!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      messageAction(id: $id) {
        id
        copy
      }
    }
  }
}
    `;
export type CopyCampaignMessageMutationFn = Apollo.MutationFunction<CopyCampaignMessageMutation, CopyCampaignMessageMutationVariables>;

/**
 * __useCopyCampaignMessageMutation__
 *
 * To run a mutation, you first call `useCopyCampaignMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyCampaignMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyCampaignMessageMutation, { data, loading, error }] = useCopyCampaignMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCopyCampaignMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CopyCampaignMessageMutation, CopyCampaignMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CopyCampaignMessageMutation, CopyCampaignMessageMutationVariables>(CopyCampaignMessageDocument, options);
      }
export type CopyCampaignMessageMutationHookResult = ReturnType<typeof useCopyCampaignMessageMutation>;
export type CopyCampaignMessageMutationResult = Apollo.MutationResult<CopyCampaignMessageMutation>;
export type CopyCampaignMessageMutationOptions = Apollo.BaseMutationOptions<CopyCampaignMessageMutation, CopyCampaignMessageMutationVariables>;
export const CopyTopicShareActionDocument = gql`
    mutation copyTopicShareAction($id: PositiveInt!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      topicShareAction(id: $id) {
        id
        copy
      }
    }
  }
}
    `;
export type CopyTopicShareActionMutationFn = Apollo.MutationFunction<CopyTopicShareActionMutation, CopyTopicShareActionMutationVariables>;

/**
 * __useCopyTopicShareActionMutation__
 *
 * To run a mutation, you first call `useCopyTopicShareActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyTopicShareActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyTopicShareActionMutation, { data, loading, error }] = useCopyTopicShareActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCopyTopicShareActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CopyTopicShareActionMutation, CopyTopicShareActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CopyTopicShareActionMutation, CopyTopicShareActionMutationVariables>(CopyTopicShareActionDocument, options);
      }
export type CopyTopicShareActionMutationHookResult = ReturnType<typeof useCopyTopicShareActionMutation>;
export type CopyTopicShareActionMutationResult = Apollo.MutationResult<CopyTopicShareActionMutation>;
export type CopyTopicShareActionMutationOptions = Apollo.BaseMutationOptions<CopyTopicShareActionMutation, CopyTopicShareActionMutationVariables>;
export const CopySurveyShareActionDocument = gql`
    mutation copySurveyShareAction($id: PositiveInt!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      surveyShareAction(id: $id) {
        id
        copy
      }
    }
  }
}
    `;
export type CopySurveyShareActionMutationFn = Apollo.MutationFunction<CopySurveyShareActionMutation, CopySurveyShareActionMutationVariables>;

/**
 * __useCopySurveyShareActionMutation__
 *
 * To run a mutation, you first call `useCopySurveyShareActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopySurveyShareActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copySurveyShareActionMutation, { data, loading, error }] = useCopySurveyShareActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCopySurveyShareActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CopySurveyShareActionMutation, CopySurveyShareActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CopySurveyShareActionMutation, CopySurveyShareActionMutationVariables>(CopySurveyShareActionDocument, options);
      }
export type CopySurveyShareActionMutationHookResult = ReturnType<typeof useCopySurveyShareActionMutation>;
export type CopySurveyShareActionMutationResult = Apollo.MutationResult<CopySurveyShareActionMutation>;
export type CopySurveyShareActionMutationOptions = Apollo.BaseMutationOptions<CopySurveyShareActionMutation, CopySurveyShareActionMutationVariables>;
export const CopyPathwayShareActionDocument = gql`
    mutation copyPathwayShareAction($id: PositiveInt!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      pathwayShareAction(id: $id) {
        id
        copy
      }
    }
  }
}
    `;
export type CopyPathwayShareActionMutationFn = Apollo.MutationFunction<CopyPathwayShareActionMutation, CopyPathwayShareActionMutationVariables>;

/**
 * __useCopyPathwayShareActionMutation__
 *
 * To run a mutation, you first call `useCopyPathwayShareActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyPathwayShareActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyPathwayShareActionMutation, { data, loading, error }] = useCopyPathwayShareActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCopyPathwayShareActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CopyPathwayShareActionMutation, CopyPathwayShareActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CopyPathwayShareActionMutation, CopyPathwayShareActionMutationVariables>(CopyPathwayShareActionDocument, options);
      }
export type CopyPathwayShareActionMutationHookResult = ReturnType<typeof useCopyPathwayShareActionMutation>;
export type CopyPathwayShareActionMutationResult = Apollo.MutationResult<CopyPathwayShareActionMutation>;
export type CopyPathwayShareActionMutationOptions = Apollo.BaseMutationOptions<CopyPathwayShareActionMutation, CopyPathwayShareActionMutationVariables>;
export const CopyCampaignEmailDocument = gql`
    mutation copyCampaignEmail($id: PositiveInt!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      emailAction(id: $id) {
        id
        copy
      }
    }
  }
}
    `;
export type CopyCampaignEmailMutationFn = Apollo.MutationFunction<CopyCampaignEmailMutation, CopyCampaignEmailMutationVariables>;

/**
 * __useCopyCampaignEmailMutation__
 *
 * To run a mutation, you first call `useCopyCampaignEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyCampaignEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyCampaignEmailMutation, { data, loading, error }] = useCopyCampaignEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCopyCampaignEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CopyCampaignEmailMutation, CopyCampaignEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CopyCampaignEmailMutation, CopyCampaignEmailMutationVariables>(CopyCampaignEmailDocument, options);
      }
export type CopyCampaignEmailMutationHookResult = ReturnType<typeof useCopyCampaignEmailMutation>;
export type CopyCampaignEmailMutationResult = Apollo.MutationResult<CopyCampaignEmailMutation>;
export type CopyCampaignEmailMutationOptions = Apollo.BaseMutationOptions<CopyCampaignEmailMutation, CopyCampaignEmailMutationVariables>;
export const CopyCampaignBannerDocument = gql`
    mutation copyCampaignBanner($id: PositiveInt!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      banner(id: $id) {
        id
        copy
      }
    }
  }
}
    `;
export type CopyCampaignBannerMutationFn = Apollo.MutationFunction<CopyCampaignBannerMutation, CopyCampaignBannerMutationVariables>;

/**
 * __useCopyCampaignBannerMutation__
 *
 * To run a mutation, you first call `useCopyCampaignBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyCampaignBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyCampaignBannerMutation, { data, loading, error }] = useCopyCampaignBannerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCopyCampaignBannerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CopyCampaignBannerMutation, CopyCampaignBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CopyCampaignBannerMutation, CopyCampaignBannerMutationVariables>(CopyCampaignBannerDocument, options);
      }
export type CopyCampaignBannerMutationHookResult = ReturnType<typeof useCopyCampaignBannerMutation>;
export type CopyCampaignBannerMutationResult = Apollo.MutationResult<CopyCampaignBannerMutation>;
export type CopyCampaignBannerMutationOptions = Apollo.BaseMutationOptions<CopyCampaignBannerMutation, CopyCampaignBannerMutationVariables>;
export const CopyCertificationShareActionDocument = gql`
    mutation copyCertificationShareAction($id: PositiveInt!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      certificationShareAction(id: $id) {
        id
        copy
      }
    }
  }
}
    `;
export type CopyCertificationShareActionMutationFn = Apollo.MutationFunction<CopyCertificationShareActionMutation, CopyCertificationShareActionMutationVariables>;

/**
 * __useCopyCertificationShareActionMutation__
 *
 * To run a mutation, you first call `useCopyCertificationShareActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyCertificationShareActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyCertificationShareActionMutation, { data, loading, error }] = useCopyCertificationShareActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCopyCertificationShareActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CopyCertificationShareActionMutation, CopyCertificationShareActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CopyCertificationShareActionMutation, CopyCertificationShareActionMutationVariables>(CopyCertificationShareActionDocument, options);
      }
export type CopyCertificationShareActionMutationHookResult = ReturnType<typeof useCopyCertificationShareActionMutation>;
export type CopyCertificationShareActionMutationResult = Apollo.MutationResult<CopyCertificationShareActionMutation>;
export type CopyCertificationShareActionMutationOptions = Apollo.BaseMutationOptions<CopyCertificationShareActionMutation, CopyCertificationShareActionMutationVariables>;